export default {"src":"/_next/static/media/IPG.cb4be67f.svg","height":18,"width":18};